module.exports = __webpack_public_path__ + "assets/img/modal-avatar-173af7a7.png";